import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Toilet = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="toilet"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path d="M43.9717 17.3132C46.2135 17.3132 48.03 15.4986 48.03 13.2582C48.03 11.0163 46.2134 9.20166 43.9717 9.20166C41.7311 9.20166 39.9163 11.0163 39.9163 13.2582C39.9163 15.4986 41.7311 17.3132 43.9717 17.3132Z" />
        <path d="M54.8424 31.8051L49.0567 19.132C48.7443 18.442 48.0362 18.144 47.3185 18.144C44.82 18.144 43.3709 18.1431 40.6259 18.1431C39.9081 18.1431 39.2003 18.4411 38.8867 19.132L33.1025 31.8051C32.7034 32.677 33.0878 33.7061 33.9587 34.1039C34.1927 34.2099 34.4377 34.2612 34.6778 34.2612C35.337 34.2612 35.9674 33.8841 36.2576 33.2459L39.0546 27.1168V33.7192C39.0546 33.7307 39.0487 33.7408 39.0487 33.7523V48.716C39.0487 49.8662 39.9806 50.7981 41.1301 50.7981C42.28 50.7981 43.2115 49.8662 43.2115 48.716V36.3106H44.7314V48.716C44.7314 49.8662 45.6631 50.7981 46.8127 50.7981C47.9622 50.7981 48.8942 49.8662 48.8942 48.716V33.7523C48.8942 33.7432 48.8897 33.7366 48.8897 33.7275V27.1168L51.6871 33.2459C51.9769 33.884 52.6076 34.2612 53.2659 34.2612C53.5062 34.2612 53.752 34.2099 53.9863 34.1039C54.857 33.7061 55.2411 32.677 54.8424 31.8051Z" />
        <path d="M16.0281 17.3132C18.2689 17.3132 20.0838 15.4986 20.0838 13.2582C20.0838 11.0163 18.2689 9.20166 16.0281 9.20166C13.7863 9.20166 11.9706 11.0163 11.9706 13.2582C11.9706 15.4986 13.7863 17.3132 16.0281 17.3132Z" />
        <path d="M21.1129 19.1323C20.8273 18.5048 20.2116 18.1434 19.5647 18.131L12.4868 18.1304C11.8398 18.1435 11.2278 18.5048 10.9429 19.1324L5.15766 31.8053C4.75883 32.6772 5.14296 33.7063 6.0137 34.1041C6.24784 34.2101 6.49356 34.2614 6.73384 34.2614C7.39228 34.2614 8.02284 33.8843 8.31285 33.2461L10.113 29.3022L8.54548 36.6819C8.49243 36.9306 8.55505 37.1892 8.7144 37.3866C8.87485 37.5843 9.11494 37.6986 9.36841 37.6986H11.1058V48.7161C11.1058 49.8663 12.0375 50.7982 13.1873 50.7982C14.3368 50.7982 15.2687 49.8663 15.2687 48.7161V37.6987H16.7884V48.7162C16.7884 49.8664 17.7203 50.7983 18.8699 50.7983C20.0195 50.7983 20.9513 49.8664 20.9513 48.7162V37.6987H22.6826C22.936 37.6987 23.1764 37.5844 23.3359 37.3867C23.4959 37.1893 23.5588 36.9306 23.5056 36.682L21.9345 29.2841L23.7423 33.2461C24.0325 33.8842 24.663 34.2614 25.3221 34.2614C25.5627 34.2614 25.8072 34.2101 26.0415 34.1041C26.9125 33.7063 27.2966 32.6772 26.8976 31.8053L21.1129 19.1323Z" />
        <path d="M30.1024 12.1787C29.3349 12.1787 28.7141 12.8005 28.7141 13.567V46.5573C28.7141 47.3238 29.3349 47.9454 30.1024 47.9454C30.8695 47.9454 31.4906 47.3238 31.4906 46.5573V13.567C31.4906 12.8006 30.8695 12.1787 30.1024 12.1787Z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="50" height="50" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Toilet.defaultProps = {
  className: null,
};

Toilet.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Toilet;
